<!-- 해당 파일 수정시, LectureSurveyPaperDetailView 파일도 함께 검토 후 수정 -->
<script setup>
import { ref, onMounted, getCurrentInstance, inject } from 'vue'
import { useRoute, useRouter, RouterLink } from 'vue-router'
import { storeToRefs } from "pinia";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useUserStore} from "../../../../user/stores/user";
import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue';
import SNBPartAdmin from "../../../../../layouts/nav/SNBPartAdmin.vue";
import moment from "moment";
import surveyService from "../../../../admin/services/lecture/surveyService";
import LectureSurveyPreviewModal from "../../../../admin/components/modal/lecture/LectureSurveyPreviewModal.vue";
import LectureSurveyModal from "../../../../user/components/modal/mypage/LectureSurveyModal.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import { useAlertStore } from '../../../../../stores/alertStore';
const {$alert, $confirm} = useAlertStore();
const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const userStore = useUserStore()
const { isPartAdmin } = storeToRefs(userStore);

const { $toast, $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

onMounted(()=>{
    const { id } = route.params;
    if(!id) {
        router.push({name: 'PartnerLectureSurveyPaperList'});
    } else {
        retrieveSurveyPaperDetail(id);
        retrieveSurveyPaperQuestionDetail(id);
        retrieveSurveyPaperDeletable(id);
    }
})

const lectureSurveyModal = ref(null)
const surveyPreviewModal = ref(null)
const surveyPaperRelatedCount = ref({});
const deletable = ref(true);

const tabIndex = ref(0)

const defaultDownloadCount = 500 // 500

const input = ref({
  title: '',
})

// 만족도 평가 기본정보
const surveyPaperDetail = ref({
    surveyId: route.params.id || '',
    title: '',
    useYn: 'Y',
    totalLecture: '',
    totalSubmit: '',
    recentSurveyDate: '',
    createDate: '',
    modifyDate: '',
});
const surveyPaperQuestionList = ref([]); // 만족도 평가 기본정보 평가문항
const surveyPaperLectureList = ref([]);  // 만족도 평가 연결된 강의
const surveyPaperUserList = ref([]);  // 만족도 평가 설문결과

// 설문결과 조회조건
const _searchInput = ref({
    searchType: 'all', // all 전체, lectName 강의명, userName 회원이름, userLoginId 회원로그인아이디
    searchInput: '',
})

const totalLectureCount = ref(0); // 연결된 강의 수
const totalCount = ref(0);  // 설문결과 수
const currentPage = ref(1); // 설문결과 현재 페이지
const pageSize = ref(30);   // 설문결과 페이지별 크기
const totalPages = ref(0);  // 설문결과 총 페이지

const searchTypeGroup = [
    { label:'전체', value:'all', },
    { label:'강의명', value:'lectName', },
    { label:'참여자', value:'userName', },
    { label:'참여자 아이디', value:'userLoginId', },
]

// 만족도 평가 기본정보 > 기본정보 조회
const retrieveSurveyPaperDetail = async (id) => {
    loadingStore.loading = true;
    surveyService.retrieveSurveyPaper(id, 0)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                surveyPaperDetail.value = result;
                input.value.title = result.title;
            }
        }).catch( async (err) =>  {
            // console.log(res);
            loadingStore.loading = false;
            // $toast('error', '오류가 발생하였습니다.');
            if (err.response && err.response.data && err.response.data.msg) {
                const mod = await $alert(err.response.data.msg);
                if( mod ) {
                    router.go(-1);
                }
            } else {
                console.log(err);
            }
    });
}

// 만족도 평가 기본정보 > 평가문항 조회
const retrieveSurveyPaperQuestionDetail = (id) => {
    loadingStore.loading = true;
    surveyService.retrievePaperQuestion(id)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                surveyPaperQuestionList.value = result;
            }
        }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
    });
}

// 연결된 강의 조회
const retrieveSurveyPaperLecture = (id) => {
    loadingStore.loading = true;
    surveyService.retrieveLectureBySurveyId(id)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                totalLectureCount.value = result.totalElements;
                surveyPaperLectureList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
            console.log("surveyPaperLectureList.userLectureSelCount : " + surveyPaperLectureList.value[0].userLectureSelCount);
        }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
    });
}

// 설문결과 조회 (페이징)
const retrieveSurveyUserSubmit = (id) => {
    let paramObj = {
        surveyId: id,
        pageNo: currentPage.value,
        size: pageSize.value,
        searchType: _searchInput.value.searchType,
        searchInput: _searchInput.value.searchInput,
    }

    loadingStore.loading = true;
    surveyService.retrieveUserSubmitAllPaging(paramObj)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                surveyPaperUserList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
    });
}

const retrieveSurveyPaperDeletable = (id) => {
    loadingStore.loading = true;
    surveyService.retrieveSurveyPaperDeletable(id)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                surveyPaperRelatedCount.value = result;
                if ( surveyPaperRelatedCount.value.lectureCount > 0 ) {
                    deletable.value = false;
                } else {
                    deletable.value = true;
                }
            }
        }).catch( (error) =>  {
        loadingStore.loading = false;
        console.log(error);
    });
}

// 목록 버튼
const goBack = () => {
    router.push({name:'PartnerLectureSurveyPaperList'})
}

// 미리보기 버튼
const onClickPreviewModal = () => {
    lectureSurveyModal.value.init(0, 0, 0, surveyPaperDetail.value.surveyId)
    lectureSurveyModal.value.show();
}

// 만족도 평가 복사
const copySurveyPaper = () => {
    router.push( { name:'PartnerLectureSurveyPaperCreate', params:{id: surveyPaperDetail.value.surveyId} } )
}

// 삭제 버튼
const onDeleteSurveyPaper = async () => {
    if ( surveyPaperRelatedCount.value.lectureCount > 0 ) {
        $alert("연결된 강의가 있는 만족도 평가는 삭제할 수 없습니다.");
        return false;
    } else {
        const ok = await $confirm(["만족도 평가를 삭제할까요?", "삭제 시 만족도 평가 설문 결과 등 모든 정보가", "삭제되며 되돌릴 수 없습니다."], "삭제");
        if(ok){
            _deleteSurveyPaper()
        }
    }
}

// 만족도 평가 삭제 처리
function _deleteSurveyPaper() {
    loadingStore.loading = true;
    surveyService.deleteSurveyPaper(surveyPaperDetail.value.surveyId)
        .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                goBack();
            } else {
                $alert("삭제를 실패하였습니다.");
            }
        }).catch( (res) =>  {
            loadingStore.loading = false;
            $alert("삭제를 실패하였습니다.");
        });
}

// 탭 선택
const onSelectTab = (option) => {
    tabIndex.value = option.value;
    //currentPage.value = 1;
    if(tabIndex.value === 0) { // 기본 정보
        retrieveSurveyPaperDetail(surveyPaperDetail.value.surveyId);
        retrieveSurveyPaperQuestionDetail(surveyPaperDetail.value.surveyId);
    } else if(tabIndex.value === 1) { // 연결된 강의
        retrieveSurveyPaperLecture(surveyPaperDetail.value.surveyId);
    } else if(tabIndex.value === 2) { // 설문 결과
        retrieveSurveyUserSubmit(surveyPaperDetail.value.surveyId);
    }
    //initValuesByTab();
}

// 연결된 강의 > 강의명 클릭(새창)
const onClickLectId = (lectId) => {
    window.open(`/admin/lecture/manage/detail/${lectId}`, '_blank');
}

// 설문결과 > row 클릭(새창)
const onClickSurveyPaperUser = (surveyPaperUser) => {
    surveyPreviewModal.value.init(surveyPaperUser.userId, surveyPaperUser.lectId, surveyPaperUser.regDt, surveyPaperDetail.value.surveyId)
    surveyPreviewModal.value.show();
}

// 설문결과 > 검색범위 셀렉트박스 변경
const onSelectSearchTypeGroup = (option) => {
    _searchInput.value.searchType = option.value;
}

// 설문결과 > 검색버튼 클릭
const onClickSearch = (value) => {
    _searchInput.value.searchInput = value;
    currentPage.value = 1;
    retrieveSurveyUserSubmit(surveyPaperDetail.value.surveyId);
}

const changeform = () => {
  originTitle.style.display = "none";
  newTitle.style.display = "block";
}

const updateSurveyTitle = () => {
  // const { surveyId, title, userYn } = input.value;
  const surveyId = surveyPaperDetail.value.surveyId;
  const title = input.value.title;
  const useYn = surveyPaperDetail.value.useYn
  if(!title) {
    $alert("만족도 평가 제목을 작성해 주세요.");
  } else {
    let paramObj = {
      surveyId: surveyId,
      title: title,
      useYn: useYn,
    }
    loadingStore.loading = true;
    surveyService.updateSurveyPaper(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            originTitle.style.display = "block";
            newTitle.style.display = "none";
            retrieveSurveyPaperDetail(surveyId);
          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

// 만족도 평가 설문 결과 다운로드
const onClickExcelDownload = async () => { // 엑셀 다운로드
    if(totalCount.value > 0 && totalCount.value < defaultDownloadCount) {
        const ok = await $confirm(["만족도 조사 결과를 내 PC로 다운로드할까요?", "다운로드 시 만족도 조사 결과가", "엑셀 파일로 저장됩니다."], "다운로드");
        if(ok){
            downloadSurveyAnswers();
        }
    } else if(totalCount.value >= defaultDownloadCount) {
        const ok = await $confirm(["[500건 이상] 만족도 조사 결과를 이메일로 발송할까요?"], "메일발송");
        if(ok){
            sendEmailSurveyAnswers();
        }
    } else {
        $alert("다운로드 받을 만족도 조사 결과가 존재하지 않습니다.");
        return false;
    }
}

const downloadSurveyAnswers = () => {
    $toast('', `다운로드 데이터 생성을 시작합니다.`);
    loadingStore.loading = true;
    surveyService.downloadSurveyAnswers(surveyPaperDetail.value.surveyId)
        .then( (res) => {
            loadingStore.loading = false;
            try {
                const href = URL.createObjectURL(res.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${surveyPaperDetail.value.title}_만족도 조사 결과_${moment().format("YYYYMMDDHHmmss")}.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();

                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            } catch(e) {
                console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
            }
        }).catch( (err) =>  {
            loadingStore.loading = false;
            let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
            // Blob 응답 처리
            err.response.data.text()  // Blob을 텍스트로 변환
                .then(text => {
                    try {
                        // 텍스트를 JSON으로 파싱
                        const responseData = JSON.parse(text);

                        // 메시지 추출
                        if (responseData?.result?.message) {
                            errorMessage = responseData.result.message;
                        }
                    } catch (parseError) {
                        console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
                    }
                    // Toast에 에러 메시지 표시
                    $toast('error', errorMessage);
                });
    });
}

const sendEmailSurveyAnswers = () => {
    surveyService.sendEmailSurveyAnswers(surveyPaperDetail.value.surveyId)
        .then( (res) => {
            $toast('', `이메일 발송 데이터 생성을 시작합니다.`);
        }).catch( (err) =>  {
            let errorMessage = '이메일 발송 중 오류가 발생했습니다.';
            try {
                const responseData = err.response?.data;
                if (responseData?.result?.message) {
                    errorMessage = responseData.result.message;
                }
            } catch (parseError) {
                console.error('에러 메시지 추출 중 오류가 발생했습니다.:', parseError);
            }
            // Toast에 에러 메시지 표시
            $toast('error', errorMessage);
    });
}

</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>만족도 평가 상세</h3>
        </div>
        <div class="btn-wrap space-between mb-xs">
            <div>
                <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
                <KSASecondaryButton class="gray_button" text="미리보기" @click="onClickPreviewModal" />
            </div>
            <div>
                <KSASecondaryButton class="gray_button" text="만족도 평가 복사" @click="copySurveyPaper" />
                <KSASecondaryButton class="red_button" text="삭제" @click="onDeleteSurveyPaper" :disabled="!deletable" />
            </div>
        </div>
        <KSATab style="grid-template-columns: repeat(3, 1fr);" class="mb-lg"
                :options="[
                    {label:'기본 정보', value:0},
                    {label:`연결된 강의${surveyPaperDetail.totalLecture > 0 ? ('(' + surveyPaperDetail.totalLecture + ')') : ''}`, value:1},
                    {label:`설문 결과${surveyPaperDetail.totalSubmit > 0 ? ('(' + surveyPaperDetail.totalSubmit + ')') : ''}`, value:2},
                ]"
                @change="onSelectTab"
        />

        <!-- s: 기본 정보 -->
        <div v-show="tabIndex === 0">
            <div class="content-inner mb-lg">
                <div class="content-title">
                    <h4>기본 정보</h4>
                </div>
                <div class="content-item">
                    <div class="table-form">
                        <table class="vertical">
                            <colgroup>
                                <col width="200px" />
                                <col />
                                <col width="200px" />
                                <col />
                            </colgroup>
                            <tr>
                                <th>사용 여부</th>
                                <td colspan="3">{{ surveyPaperDetail.useYn === 'Y' ? '사용' : '미사용'}}</td>
                            </tr>
                            <tr>
                                <th>만족도 평가 제목</th>
                                <td id="originTitle"><span style="float:left; width: 80%;">{{ surveyPaperDetail.title }}</span><span style="float:right;"><KSAPrimaryButton text="제목 수정" @click="changeform" /></span></td>
                                <td id="newTitle" style="display: none;" ><span style="float:left; width: 80%;"><KSAInput class="text-box" v-model="input.title" /></span><span style="float:right;"><KSAPrimaryButton text="저장" @click="updateSurveyTitle" /></span></td>
                                <th>참여 인원</th>
                                <td>{{ $numberZero(surveyPaperDetail.totalSubmit) }} 명</td>
                            </tr>
                            <tr>
                                <th>등록일</th>
                                <td>{{ $yyyymmddHHmm(surveyPaperDetail.createDate) }}</td>
                                <th>최근 설문일</th>
                                <td>{{ $yyyymmddHHmm(surveyPaperDetail.recentSurveyDate) }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>

            <div class="content-inner">
                <div class="content-title">
                    <h4>평가 문항({{ surveyPaperQuestionList.length }})</h4>
                </div>
                <div class="content-item">
                    <div class="table-form">
                        <table class="horizontal">
                            <tr>
                                <th></th>
                                <th>문항 구분</th>
                                <th>문항 유형</th>
                                <th>문항</th>
                                <th>다중응답형 보기</th>
                            </tr>
                            <tr v-for="(surveyPaperQuestion, index) in surveyPaperQuestionList">
                                <td>{{ index+1 }}</td>
                                <td>{{ $gbNameKR('SURVEY_Q_TYPE', surveyPaperQuestion.surveyQType) }}</td>
                                <td>{{ $gbNameKR('SURVEY_Q_GB', surveyPaperQuestion.surveyQGb) }}</td>
                                <td class="text-left">{{ surveyPaperQuestion.surveyQTitle }}</td>
                                <td v-if="surveyPaperQuestion.choiceList !== null">
                                    <span v-for="(choice, index) in surveyPaperQuestion.choiceList">
                                        {{ index+1 }}. {{ choice.surveyChoiceContent }}
                                    <br /></span>
                                    <span v-if="surveyPaperQuestion.etcYn === 'Y'">
                                        {{ surveyPaperQuestion.choiceList.length+1 }}. 기타
                                    </span>
                                </td>
                                <td v-if="surveyPaperQuestion.pointOptions !== null">
                                    <span v-for="(point, index) in surveyPaperQuestion.pointOptions">
                                        {{ index+1 }}. {{ point.surveyChoiceContent }}
                                    <br /></span>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="surveyPaperQuestionList.length === 0">
                            검색 결과가 없습니다.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- e: 기본 정보 -->

                <!-- s: 연결된 강의 -->
                <div v-show="tabIndex === 1">
                    <div class="list-top">
                        <p>총 <span v-if="totalLectureCount === null">0</span> <span v-else>{{totalLectureCount}}</span> 개</p>
                    </div>
                    <div class="table-form">
                        <table class="horizontal">
                            <tr>
                                <th>구분</th>
                                <th>강의명</th>
                                <th>교육 기간</th>
                                <th>설문 제출자/수강생</th>
                                <th>설문 결과</th>
                                <th>수강 관리</th>
                            </tr>
                            <tr v-for="(surveyPaperLecture, index) in surveyPaperLectureList">
                                <td>{{ surveyPaperLecture.lectGb === '01' ? '온라인' : '오프라인'}}</td>
                                <td class="text-left"><KSATextButton :text="surveyPaperLecture.lectName" @click="onClickLectId(surveyPaperLecture.lectId)" /></td>
                                <td>
                                    <span v-if="surveyPaperLecture.lectTermGb === '01'">신청일로부터 {{ surveyPaperLecture.lectTerm }}일</span>
                                    <span v-else>{{ $yyyymmdd(surveyPaperLecture.lectStartYmd) }} ~ {{ $yyyymmdd(surveyPaperLecture.lectEndYmd) }}</span>
                                </td>
                                <td>
                                    <span v-if="surveyPaperLecture.userLectureSelCount === null || surveyPaperLecture.userLectureSelCount === '' ">-</span>
                                    <span v-else>{{ $numberZero(surveyPaperLecture.totalSubmit) }}/{{ surveyPaperLecture.userLectureSelCount }}</span>
                                </td>
                                <td>
                                    <span v-if="surveyPaperLecture.avgResult === null || surveyPaperLecture.avgResult === '' ">-</span>
                                    <span v-else>{{ surveyPaperLecture.avgResult }}</span>
                                </td>
                                <td class="link text-center">
                                    <RouterLink :to="{name: 'PartnerLectureCourseDetail', params: {id: surveyPaperLecture.lectId }}">수강 관리</RouterLink>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="surveyPaperLectureList.length === 0">
                            연결된 강의가 없습니다.
                        </div>
                    </div>
                </div>
                <!-- e: 연결된 강의 -->

        <!-- s: 설문 결과 -->
        <div v-show="tabIndex === 2">
            <div class="list-top">
                <div class="grid">
                <KSASecondaryButton class="gray_button" text="엑셀 다운로드" @click="onClickExcelDownload" />
                </div>
            </div>
            <div class="list-top">
                <p>총 <span v-if="totalCount === null">0</span><span v-else>{{totalCount}}</span> 개</p>
                <div class="search-box">
                    <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="search-select" @selectOption="onSelectSearchTypeGroup"/>
                    <KSASearchInputBox placeholder="검색어를 입력하세요." class="search-input" @search="onClickSearch" />
                </div>
            </div>
            <div class="table-form">
                <table class="horizontal">
                    <tr>
                        <th>번호</th>
                        <th>구분</th>
                        <th>강의명</th>
                        <th>참여자</th>
                        <th>참여자 아이디</th>
                        <th>설문 결과</th>
                        <th>설문일</th>
                    </tr>
                    <tr v-for="(surveyPaperUser, index) in surveyPaperUserList" @click="onClickSurveyPaperUser(surveyPaperUser)">
                        <td>{{ surveyPaperUser.boardNo }}</td>
                        <td>{{ surveyPaperUser.lectGb === '01' ? '온라인' : '오프라인'}}</td>
                        <td>{{ surveyPaperUser.lectName }}</td>
                        <td>{{ surveyPaperUser.userName }}</td>
                        <td>{{ surveyPaperUser.userLoginId }}</td>
                        <td>{{ $number(surveyPaperUser.result) }}</td>
                        <td>{{ $yyyymmddOrHHmm(surveyPaperUser.surveyDt) }}</td>
                    </tr>
                </table>
                <div class="result-none" v-if="surveyPaperUserList.length === 0">
                    설문 결과가 없습니다.
                </div>
            </div>
        </div>
        <!-- e: 설문 결과 -->
    </div>
    <LectureSurveyModal ref="lectureSurveyModal" />
    <LectureSurveyPreviewModal ref="surveyPreviewModal"/>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.table-form {
  table {
    &.vertical {
      td {
        .horizontal {
          th {
            text-align: center;
          }
        }
      }
    }
    &.horizontal {
      tr:hover {
        background: transparent;
      }
    }
  }
}
</style>